import imageCompression from 'browser-image-compression'
import { putObject, deleteObject, getRegionFromUrl } from './s3'

const randomString = () => `${Math.floor(Math.random() * 90000 + 10000)}`

const createObjectKey = (type, entityId, filename) => {
  const isDev = process.env.NODE_ENV === 'development'
  const random = randomString()
  entityId = entityId.replace(/\//g, '_')
  return `${type}${isDev ? '-dev' : ''}-${entityId}-${random}-${filename}`
}

const getObjectKeyFromUrl = (url) => url.substr(url.lastIndexOf('/') + 1)

const compressImageFile = async (file) => {
  try {
    // Light client-side downscale only — the backend converts to WebP and
    // enforces the final main (4 MB) / thumbnail (300 KB) budgets. Keep the
    // request under the server's 15 MB cap.
    return await imageCompression(file, {
      maxSizeMB: 14,
      maxWidthOrHeight: 2560,
      useWebWorker: true,
    })
  } catch (_err) {
    return file
  }
}

export const uploadImage = async (type, file, entityId) => {
  entityId = entityId || randomString()
  const compressed = await compressImageFile(file)
  return putObject({
    Body: compressed,
    Key: createObjectKey(type, entityId, compressed.name || file.name),
    ContentType: compressed.type || file.type
  })
}

export const deleteImage = (url) => {
  const objectKey = getObjectKeyFromUrl(url)
  if (!objectKey) {
    return Promise.reject('cannot get object key from url')
  }
  return deleteObject({ Key: objectKey }, getRegionFromUrl(url))
}

export const uploadImages = (
  type,
  files,
  entityId,
  progressCallback
) => {
  entityId = entityId || randomString()
  const results = []
  return files.reduce((task, file) => {
    return task.then(() => {
      return uploadImage(type, file, entityId)
        .then((url) => {
          results.push(url)
        }, () => {
          results.push(null)
        })
        .then(() => {
          if (progressCallback) {
            progressCallback(results)
          }
        })
    })
  }, Promise.resolve()).then(() => {
    return results
  })
}

export const uploadInventoryImage = uploadImage.bind(null, 'inventory')
export const uploadInventoryImages = uploadImages.bind(null, 'inventory')
export const uploadRetailerImage = uploadImage.bind(null, 'retailer')
export const uploadRetailerImages = uploadImages.bind(null, 'retailer')

export default {
  uploadInventoryImage,
  uploadInventoryImages,
  uploadRetailerImage,
  uploadRetailerImages,
  deleteImage
}
